import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Select,
  Input,
  DatePicker,
  Button,
  message,
  Divider,
  InputNumber,
  Row,
  Col,
} from "antd";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import moment from "moment";

const { Option } = Select;

export const BranchAssetsModalUpdate = ({ asset, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [branches, setBranches] = useState([]);
  const [fetchingBranches, setFetchingBranches] = useState(false);

  useEffect(() => {
    fetchBranches();
    // Pre-fill form when component mounts
    if (asset) {
      form.setFieldsValue({
        ...asset,
        WifiBillDueDate: asset.wifiBillDueDate
          ? moment(asset.wifiBillDueDate)
          : null,
      });
    }
  }, [asset, form]);

  const fetchBranches = async () => {
    setFetchingBranches(true);
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setBranches(response?.data?.data || []);
    } catch (error) {
      message.error("Failed to load branches");
    } finally {
      setFetchingBranches(false);
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        Id: asset.id, // Primary Key for Update
        BranchId: values.BranchId,
        WifiName: values.WifiName,
        WifiBillDueDate: values.WifiBillDueDate.format("YYYY-MM-DD"),
        PrinterCount: values.PrinterCount || 0,
        CCTVCount: values.CCTVCount || 0,
        MNTRACount: values.MNTRACount || 0,
      };

      const response = await axios.put(
        `${Api_Url}api/v1/BranchAssets/${asset.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );

      if (response.status === 200) {
        message.success("Branch assets updated successfully");
        onSuccess();
      }
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to update assets");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <span style={{ fontSize: "18px", fontWeight: "bold" }}>
          Update Branch Assets - ID #{asset?.id}
        </span>
      }
      open={true}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Update Record
        </Button>,
      ]}
      centered
      width={700}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="BranchId"
              label="Branch"
              rules={[{ required: true, message: "Please select a branch" }]}
            >
              <Select
                showSearch
                placeholder="Search branch"
                optionFilterProp="children"
                loading={fetchingBranches}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {branches.map((b) => (
                  <Option key={b.id} value={b.id}>
                    {b.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="WifiBillDueDate"
              label="Wifi Bill Due Date"
              rules={[{ required: true, message: "Please select due date" }]}
            >
              <DatePicker style={{ width: "100%" }} format="DD-MM-YYYY" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="WifiName"
          label="Wifi Name / SSID"
          rules={[{ required: true, message: "Please enter Wifi name" }]}
        >
          <Input placeholder="e.g. Roha_Noida_5G" />
        </Form.Item>

        <Divider plain>Asset Counts</Divider>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="PrinterCount" label="Printers">
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="CCTVCount" label="CCTV Cameras">
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="MNTRACount" label="MNTRA Devices">
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
